import Timing from "core/timing";
import Animations from "./animations";
export default function Physics(level) {
  const animations = Animations();
  const plugins = [];
  let enabled = true;
  const physics = {
    update,
    addPlugin,
    setEnabled,
    animations
  };
  function update(p) {
    if (!enabled) return;
    const timer = Timing.start("physics");
    plugins.forEach(plugin => plugin(level, physics));
    animations.tick(p);
    timer.stop();
  }
  function addPlugin(plugin) {
    plugins.push(plugin);
  }
  function setEnabled(enab) {
    enabled = enab;
  }
  return physics;
}